module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/search-account/search-account.component.css
// module id = ./src/app/search-account/search-account.component.css
// module chunks = main